import { DepotStatusKeys, tablePaginationInitialValue } from "@evr/constant";
import { DepotState } from "@evr/types";

export const depotInitialState: DepotState = {
  currentDepot: null,
  status: DepotStatusKeys.CLOSE,
  pagination: tablePaginationInitialValue,
};
